export interface DeviceInfo {
  os: string
  browser: string
}

export function getDeviceInfo(userAgent = navigator.userAgent): DeviceInfo {
  const os = /iPhone|iPad|iPod/i.test(userAgent)
    ? 'iOS'
    : /Android/i.test(userAgent)
      ? 'Android'
      : /Windows/i.test(userAgent)
        ? 'Windows'
        : /Mac OS X/i.test(userAgent)
          ? 'macOS'
          : 'Other'

  const browser = /SamsungBrowser/i.test(userAgent)
    ? 'Samsung Internet'
    : /CriOS/i.test(userAgent)
      ? 'Chrome iOS'
      : /FxiOS/i.test(userAgent)
        ? 'Firefox iOS'
        : /EdgiOS|EdgA|Edg\//i.test(userAgent)
          ? 'Edge'
          : /Chrome/i.test(userAgent)
            ? 'Chrome'
            : /Safari/i.test(userAgent)
              ? 'Safari'
              : 'Other'

  return { os, browser }
}
